import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import PhoneInput from 'react-phone-input-2';
import Form from 'react-bootstrap/Form';
import LoadingAlert from '../Alerts/LoadingAlert';
import ErrorAlert from '../Alerts/ErrorAlert';
import { ClientsFetchAPI } from '../../api/Clients';
import { MailFetchAPI } from '../../api/Mail';
import HeaderMain from '../Home/Headers/HeaderMain';
import { authenticationDgi } from '../../utils/AuthDgi';
import { useTranslation } from 'react-i18next';

/* ─────────────────────────────────────────────────────────
   CSS — inyectado una vez. Prefijo: .ru-
───────────────────────────────────────────────────────── */
const RU_CSS = `

`;

/* ── ICONS ── */
const IcoUser   = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
const IcoMail   = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>;
const IcoPhone  = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.18 6.18l.95-.95a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
const IcoLock   = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>;
const IcoKey    = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/></svg>;
const IcoEyeOn  = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>;
const IcoEyeOff = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>;
const IcoBack   = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="15 18 9 12 15 6"/></svg>;
const IcoCheck  = ()=><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>;
const IcoCheckG = ()=><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#15803D" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>;
const IcoArrow  = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>;
const IcoWarn   = ()=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>;

/* ═══════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original
═══════════════════════════════════════════════════════════ */
const RegisterUser = ({ modalUserRegister, setModalUserRegister, setNickNameLogin, setPasswordLogin, loginUser }) => {
  const { t } = useTranslation();

  /* inject CSS once */
  useEffect(() => {
    const id = "ru-styles";
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("style");
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = RU_CSS;
  }, []);

  /* ════════════════════════════════════════════════════════
     LÓGICA ORIGINAL — 100% INTACTA
  ════════════════════════════════════════════════════════ */
  const [name, setName]                       = useState('');
  const [phone, setPhone]                     = useState('');
  const [nickNamel, setNickName]              = useState('');
  const [password, setPassword]               = useState('');
  const [Ruc, setRuc]                         = useState('');
  const [Dv, setDv]                           = useState('');
  const [passwordCheck, setPasswordCheck]     = useState('');
  const [email, setEmail]                     = useState('');
  const [codeValidation, setCodeValidation]   = useState(0);
  const [codeInput, setCodeInput]             = useState(false);
  const [codeValidInput, setCodeValidInput]   = useState('');
  const [alertpass, setAlertpass]             = useState('');
  const [alertValidPass, setAlertValidPass]   = useState([]);
  const [formError, setFormError]             = useState('');

  const cleanInputs = () => {
    setName(''); setPhone(''); setNickName(''); setPassword('');
    setPasswordCheck(''); setEmail('');
    setFormError('');
    setModalUserRegister(false);
  };

  const registerVerification = async () => {
    setFormError('');
    LoadingAlert(t('profile.register.creatingUser'));
    let token = undefined;
    let business = JSON.parse(localStorage.getItem('business'));
    let data = {
      name, phone, email, password, ruc: Ruc, dv: Dv,
      passwordCheck, business_code: business.code,
      business_id: business.id, client_type_id: 2,
    };
    try {
      const response = await ClientsFetchAPI.registerVerification(data, token);
      if (response.data && response.data.success === true) { createClient(); }
    } catch (err) {
      console.log(err);
      const message = err.response && err.response.data ? err.response.data.error : t('profile.errors.createUserError');
      setFormError(message);
      ErrorAlert('', message, 'error');
    }
  };

  const createClient = async () => {
    setFormError('');
    const responseDgi = await authenticationDgi(Ruc);
    console.log(responseDgi);
    LoadingAlert(t('profile.register.creatingUser'));
    let token = undefined;
    let business = JSON.parse(localStorage.getItem('business'));
    let data = {
      name,
      billing_name: responseDgi.billing_name ? responseDgi.billing_name : name,
      phone, email, nickname: nickNamel, password, ruc: Ruc,
      dv: responseDgi.dv ? responseDgi.dv : Dv,
      passwordCheck, business_code: business.code,
      client_type_id: responseDgi.clientType ? responseDgi.clientType : 2,
    };
    try {
      const response = await ClientsFetchAPI.createClient(data, token);
      ErrorAlert('', t('profile.register.createSuccess'), 'success');
      loginUser(email, password);
      cleanInputs();
    } catch (err) {
      setCodeInput(false);
      const message = err.response && err.response.data ? err.response.data.error : t('profile.errors.createUserError');
      setFormError(message);
      ErrorAlert('', message, 'error');
      console.log(err);
    }
  };

  const sendMailValid = () => {
    let token = undefined;
    const random4Digits = Math.floor(1000 + Math.random() * 9000);
    setCodeValidation(random4Digits);
    let data = {
      "email": email,
      "subject": "Solo falta un paso para completar tu registro",
      "text": "Hola " + name + "\n\n¡Gracias por registrarte!\nPara confirmar tu correo electrónico y activar tu cuenta, utiliza este código:\n\n" + random4Digits + "\n\nEste código expira en 10 minutos.\nSi no realizaste este registro, ignora este correo."
    };
    console.log(data);
    try {
      const response = MailFetchAPI.sendMail(data, token);
      ErrorAlert('', t('profile.register.mailSentSuccess'), 'success');
    } catch (err) {
      setCodeInput(false);
      ErrorAlert('', err.response.data ? err.response.data.error : t('profile.register.mailSendError'), 'error');
      console.log(err);
    }
  };

  const handleValidRepitpass = (value) => {
    if (password !== value) { setAlertpass(t('profile.shared.passwordMismatch')); }
    else { setAlertpass(t('profile.shared.allSet')); }
  };

  const validatePassword = (value) => {
    let errors = [];
    if (value.length < 8 || value.length > 14) errors.push(t('profile.shared.pwdRuleLength'));
    if (!/[a-z]/.test(value))                   errors.push(t('profile.shared.pwdRuleLowercase'));
    if (!/[A-Z]/.test(value))                   errors.push(t('profile.shared.pwdRuleUppercase'));
    if (!/[!@#$%^&*(),.?":{}|<>_\-+=/\\[\]]/.test(value)) errors.push(t('profile.shared.pwdRuleSymbol'));
    if (/\s/.test(value))                        errors.push(t('profile.shared.pwdRuleNoSpaces'));
    else if (errors.length === 0)                errors.push(t('profile.shared.pwdRuleValid'));
    setAlertValidPass(errors);
  };

  const [showPassword, setShowPassword] = useState('');
  const toogglePasword = () => { setShowPassword(!showPassword); };

  const [step, setStep]         = useState(1);
  const totalSteps               = 3;
  const nextStep = () => { if (step < totalSteps) { setFormError(''); setStep(step + 1); } };
  const prevStep = () => { if (step > 1) { setFormError(''); setStep(step - 1); } };
  /* ════════════════════════════════════════════════════════
     FIN LÓGICA ORIGINAL
  ════════════════════════════════════════════════════════ */

  /* ── stepper config ── */
  const STEPS = [
    { n: 1, label: t('profile.register.stepPersonal') },
    { n: 2, label: t('profile.register.stepContact') },
    { n: 3, label: t('profile.register.stepSecurity') },
  ];

  if (!modalUserRegister) return null;

  /* ── RENDER ── */
  return createPortal(
    <div className="ru-overlay">
      <HeaderMain />

      {/* top link — iniciar sesión */}
      {/* <button className="ru-top-link" onClick={() => cleanInputs()}>
        ¿Ya tienes cuenta? <span>Iniciar sesión</span>
      </button> */}

      <div className="ru-inner">
        <div className="ru-card">

          {/* ── STEPPER ── */}
          <div className="ru-stepper">
            {STEPS.map((s, i) => (
              <React.Fragment key={s.n}>
                <div className="ru-step-node">
                  <div className={`ru-step-circle${step === s.n ? ' active' : step > s.n ? ' done' : ''}`}>
                    {step > s.n
                      ? <IcoCheck />
                      : <span>{s.n}</span>
                    }
                  </div>
                  <span className={`ru-step-label${step === s.n ? ' active' : step > s.n ? ' done' : ''}`}>
                    {s.label}
                  </span>
                </div>
                {i < STEPS.length - 1 && (
                  <div className={`ru-step-connector${step > s.n ? ' done' : ''}`} />
                )}
              </React.Fragment>
            ))}
          </div>

          {/* ── HEADER ── */}
          <p className="ru-eyebrow">{t('profile.register.eyebrow')}</p>
          <h1 className="ru-title">
            {step === 1 ? t('profile.register.titleStep1') : step === 2 ? t('profile.register.titleStep2') : t('profile.register.titleStep3')}
          </h1>
          <p className="ru-subtitle">
            {step === 1 ? t('profile.register.subtitleStep1') : step === 2 ? t('profile.register.subtitleStep2') : t('profile.register.subtitleStep3')}
          </p>

          {formError && (
            <div className="ru-form-error"><IcoWarn />{formError}</div>
          )}

          {/* ── VERIFICATION CODE VIEW ── */}
          {codeInput ? (
            <div className="ru-code-wrap">
              <div className="ru-field">
                <label className="ru-label"><IcoKey /> {t('profile.register.verificationCodeLabel')}</label>
                <input
                  className="ru-code-input"
                  type="text"
                  placeholder="0000"
                  value={codeValidInput}
                  onChange={e => setCodeValidInput(e.target.value)}
                />
                <p className="ru-hint">{t('profile.register.verificationHint')}</p>
              </div>
              <div className="ru-btn-row">
                <button className="ru-btn-danger" type="button" onClick={() => setCodeInput(false)}>
                  {t('common.cancel')}
                </button>
                <button className="ru-btn-primary" type="button" onClick={() => createClient()}>
                  <IcoArrow /> {t('profile.register.verifyAndRegister')}
                </button>
              </div>
            </div>
          ) : (
            <>
              {/* ── PASO 1 — nombre + email ── */}
              {step === 1 && (
                <div className="ru-step-content">
                  <div className="ru-fields">
                    <div className="ru-field">
                      <label className="ru-label">{t('profile.shared.fullNameLabel')}</label>
                      <div className="ru-input-wrap">
                        <span className="ru-input-icon"><IcoUser /></span>
                        <input
                          className="ru-input"
                          type="text"
                          placeholder={t('profile.register.fullNamePlaceholder')}
                          onChange={e => setName(e.target.value)}
                        />
                      </div>
                      <p className="ru-hint">{t('profile.register.fullNameHint')}</p>
                    </div>

                    <div className="ru-field">
                      <label className="ru-label">{t('profile.shared.emailLabel')}</label>
                      <div className="ru-input-wrap">
                        <span className="ru-input-icon"><IcoMail /></span>
                        <input
                          className="ru-input"
                          type="email"
                          placeholder={t('profile.shared.emailPlaceholder')}
                          onChange={e => setEmail(e.target.value)}
                        />
                      </div>
                      <p className="ru-hint">{t('profile.register.emailHint')}</p>
                    </div>
                  </div>
                </div>
              )}

              {/* ── PASO 2 — teléfono + RUC/DV ── */}
              {step === 2 && (
                <div className="ru-step-content">
                  <div className="ru-fields">
                    <div className="ru-field">
                      <label className="ru-label">{t('profile.shared.phoneLabel')}</label>
                      <div className="ru-phone-wrap">
                        <PhoneInput
                          country={'pa'}
                          value={phone}
                          onChange={p => setPhone(p)}
                          inputProps={{ name: 'phone', required: true, autoFocus: true }}
                          enableSearch
                        />
                      </div>
                      <p className="ru-hint">{t('profile.register.phoneHint')}</p>
                    </div>

                    {/* RUC/DV — opcional */}
                    <div className="ru-field">
                      <details>
                        <summary className="ru-details-toggle">{t('profile.shared.rucDvLabel')} <span style={{fontWeight:400,color:'var(--text-3)',fontSize:'.7rem',marginLeft:'auto'}}>{t('profile.register.optionalLabel')}</span></summary>
                        <div className="ru-fields" style={{marginTop:'.65rem'}}>
                          <p style={{fontSize:'.73rem',color:'var(--text-3)',marginTop:'-.2rem'}}>{t('profile.register.rucOptionalHint')}</p>
                          <div className="ru-field-row">
                            <div className="ru-field">
                              <label className="ru-label">{t('profile.shared.rucNumberLabel')}</label>
                              <input className="ru-input no-icon" type="text" placeholder="0-0000-0" onChange={e => setRuc(e.target.value)} />
                            </div>
                            <div className="ru-field">
                              <label className="ru-label">{t('profile.shared.dvNumberLabel')}</label>
                              <input className="ru-input no-icon" type="number" placeholder="00" onChange={e => setDv(e.target.value)} />
                            </div>
                          </div>
                        </div>
                      </details>
                    </div>
                  </div>
                </div>
              )}

              {/* ── PASO 3 — contraseña ── */}
              {step === 3 && (
                <div className="ru-step-content">
                  <div className="ru-fields">

                    {/* contraseña */}
                    <div className="ru-field">
                      <label className="ru-label">{t('profile.shared.passwordLabel')}</label>
                      <div className="ru-input-wrap">
                        <span className="ru-input-icon"><IcoLock /></span>
                        <input
                          className="ru-input has-eye"
                          type={showPassword ? 'text' : 'password'}
                          placeholder="••••••••"
                          onChange={e => { setPassword(e.target.value); validatePassword(e.target.value); }}
                        />
                        <button className="ru-eye" type="button" onClick={toogglePasword} tabIndex={-1}>
                          {showPassword ? <IcoEyeOff /> : <IcoEyeOn />}
                        </button>
                      </div>

                      {/* reglas de contraseña */}
                      {alertValidPass.length > 0 && (
                        <div className="ru-pwd-rules">
                          {alertValidPass.map((alert, i) => (
                            <div key={i} className={`ru-pwd-rule${alert === t('profile.shared.pwdRuleValid') ? ' ok' : ''}`}>
                              <div className="ru-pwd-dot">
                                {alert === t('profile.shared.pwdRuleValid') && <IcoCheckG />}
                              </div>
                              {alert}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* repetir contraseña */}
                    <div className="ru-field">
                      <label className="ru-label">{t('profile.shared.repeatPasswordLabel')}</label>
                      <div className="ru-input-wrap">
                        <span className="ru-input-icon"><IcoLock /></span>
                        <input
                          className="ru-input has-eye"
                          type={showPassword ? 'text' : 'password'}
                          placeholder="••••••••"
                          onChange={e => { setPasswordCheck(e.target.value); handleValidRepitpass(e.target.value); }}
                        />
                        <button className="ru-eye" type="button" onClick={toogglePasword} tabIndex={-1}>
                          {showPassword ? <IcoEyeOff /> : <IcoEyeOn />}
                        </button>
                      </div>
                      {alertpass && (
                        <p className={`ru-match-msg${alertpass === t('profile.shared.passwordMismatch') ? ' err' : ' ok'}`}>
                          {alertpass}
                        </p>
                      )}
                    </div>

                    {/* mostrar contraseña */}
                    <label className="ru-check-wrap">
                      <input className="ru-check-input" type="checkbox" value="remember-me" id="flexCheckDefault" onChange={toogglePasword} />
                      <span className="ru-check-box"><IcoCheck /></span>
                      <span className="ru-check-label">{t('profile.shared.showPassword')}</span>
                    </label>

                    {/* crear cuenta */}
                    <button className="ru-btn-primary" type="button" onClick={() => registerVerification()}>
                      {t('profile.register.createAccountBtn')} <IcoArrow />
                    </button>

                    <p className="ru-terms">
                      {t('profile.register.termsPrefix')}{' '}
                      <a href="#" onClick={e => e.preventDefault()}>{t('profile.register.termsLink')}</a> {t('profile.register.and')}{' '}
                      <a href="#" onClick={e => e.preventDefault()}>{t('profile.register.privacyLink')}</a>.
                    </p>

                  </div>
                </div>
              )}

              {/* ── NAVEGACIÓN PASOS ── */}
              <div className="ru-btn-row">
                <button
                  className="ru-btn-ghost"
                  type="button"
                  onClick={prevStep}
                  disabled={step === 1}
                >
                  <IcoBack /> {t('common.previous')}
                </button>
                <button
                  className="ru-btn-primary"
                  type="button"
                  onClick={nextStep}
                  disabled={step === totalSteps}
                >
                  {t('common.next')} <IcoArrow />
                </button>
              </div>

              {/* ── YA TENGO CUENTA ── */}
              <p className="ru-footer-text">
                {t('profile.register.alreadyHaveAccount')}
                <button className="ru-footer-link" type="button" onClick={() => cleanInputs()}>
                  {t('profile.register.signIn')}
                </button>
              </p>
            </>
          )}

        </div>
      </div>
    </div>,
    document.body
  );
};

export default RegisterUser;